import { Permission } from '@bookora/shared';

import type { TourDef } from './types';

/**
 * The patient LIST (`/patients`; the file itself is `patient-file`). The
 * spreadsheet import is a desk job and is not drawn on a phone, so its step
 * skips itself there; the photo import (`import.entry`) renders only when the
 * feature, the kind and the caller's permissions allow it.
 */
export const PATIENTS_TOUR: TourDef = {
  key: 'patients',
  version: 1,
  surface: 'page',
  title: 'فهرست بیماران',
  hubDescription: 'پیدا کردن بیمار، ثبت بیمار جدید و ثبت فهرست قبلی.',
  offer: {
    body: 'در چند مرحله نشونتون می‌دیم چطور بیمار پیدا کنید، پرونده بسازید و فهرست بیماران کلینیک رو وارد کنید.',
  },
  route: { path: '/patients', match: (pathname) => pathname === '/patients' },
  requires: { all: [Permission.PATIENT_VIEW] },
  finish: {
    label: 'ثبت بیمار جدید',
    to: '/patients/new',
    requires: { all: [Permission.PATIENT_CREATE] },
  },
  autoOffer: true,
  maxSteps: 4,
  minSteps: 2,
  steps: [
    {
      id: 'find',
      anchor: 'patients.filters',
      placement: 'bottom',
      title: 'پیدا کردن بیمار',
      body: (ctx) =>
        ctx.can(Permission.PATIENT_VIEW_ALL)
          ? 'نام، موبایل، کد ملی یا شمارهٔ پرونده رو بنویسید، یا فهرست رو با فیلترها کوتاه کنید.'
          : 'نام، موبایل، کد ملی یا شمارهٔ پرونده رو بنویسید. اینجا فقط بیمارانی رو می‌بینید که پزشک معالجشون شما هستید.',
    },
    {
      id: 'create',
      anchor: 'patients.create',
      placement: 'bottom-end',
      requires: { all: [Permission.PATIENT_CREATE] },
      title: 'ثبت بیمار جدید',
      body: 'فقط نام، نام خانوادگی و موبایل لازم است؛ بقیهٔ پرونده رو هر وقت خواستید کامل کنید.',
    },
    {
      id: 'import',
      anchor: 'patients.import',
      placement: 'bottom-end',
      requires: { all: [Permission.PATIENT_CREATE] },
      title: 'ثبت فهرست قبلی',
      body: 'اگر بیماران رو در فایل اکسل دارید، همه رو یک‌جا وارد کنید؛ قبل از ثبت، پیش‌نمایش ردیف‌ها رو می‌بینید.',
    },
    {
      id: 'import-photo',
      anchor: 'import.entry',
      placement: 'bottom-end',
      title: 'فهرست روی کاغذ',
      body: 'اگر فهرست بیماران رو در دفتر یا روی کارت‌های کاغذی دارید، از برگه‌ها عکس بگیرید تا اطلاعاتشون خوانده بشه. تا بازبینی نکنید، چیزی ثبت نمی‌شه.',
    },
  ],
};
